import { handleTree } from '@/api/common';
import { getDeptList, getDictGroups } from '@/api/system/system'
export default {
  namespaced: true,
  state: {
    dictList: [],
    deptList: [],
    deptTreeList: []
  },
  mutations: {
    GET_DEPT_LIST(state, deptList) {
      let deptTreeList = handleTree(
        deptList,
        'id',
        'parentId',
        'children'
      )
      state.deptList = deptList;
      state.deptTreeList = deptTreeList;
    },
    GET_DICT_LIST(state, dictList) {
      state.dictList = dictList;
    },
  },
  actions: {
    async getDeptList({
			commit
		}, query) {
			let result = await getDeptList(query);
			if (result.code == 200 && result.flag) {
        let deptList = result.data || []
				commit('GET_DEPT_LIST', deptList);
			}
		},
    async getDictList({
			commit
		}, query) {
			let result = await getDictGroups({types: query.types});
			if (result.code == 200 && result.flag) {
        let dictList = result.data || []
        if(dictList.productType && dictList.productType.length > 0) {
          dictList.productType.some(item=>{
            item.dictLabel = item.dictLabel + query.productName
          })
        }
				commit('GET_DICT_LIST', dictList);
			}
		},
  }
}